import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=2cc2e3c1&"
import script from "./CompanyUsers.vue?vue&type=script&lang=js&"
export * from "./CompanyUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports